import { initializeConfiguration } from './app'

export const ActionTypes = {
  AUTHENTICATION_LOGIN: 'AUTHENTICATION_LOGIN',
  AUTHENTICATION_LOGOUT: 'AUTHENTICATION_LOGOUT',
  AUTHENTICATION_METADATA: 'AUTHENTICATION_METADATA',
}

export const login = user => ({
  type: ActionTypes.AUTHENTICATION_LOGIN,
  user,
})

export const logout = () => (dispatch, getState, { api }) => {
  api.logoutOnHostSite()
  dispatch({ type: ActionTypes.AUTHENTICATION_LOGOUT })
}

export const initializeAuthentication = (user, session) => (dispatch, getState, { config }) => {
  config.setToken(session)
  dispatch(login(user))
}

export const authenticationLogout = () => (dispatch, getState, { config }) => {
  // dispatch(push('/'))
  config.reset()
  dispatch(logout())
  dispatch(initializeConfiguration(true))
}

export const setupTrackjs = () => (dispatch, getState) => {
  if (window.trackJs) {
    window.trackJs.configure({
      userId: getState().authentication.id,
      version: process.env.VERSION || 'HEAD',
    })

    const platform = typeof navigator === 'undefined' ? 'Unknown' : navigator.platform
    window.trackJs.addMetadata('version', process.env.VERSION)
    window.trackJs.addMetadata('build', process.env.COMMITHASH)
    window.trackJs.addMetadata('platform', platform)
    window.trackJs.addMetadata('host', window.location.host)
    window.trackJs.addMetadata('environment', getState().app.environment)
    window.trackJs.addMetadata('isGuestUser', getState().authentication.isGuestUser)
  }
}
